// Translator notes: the age question (engine age-question.ts, rules/numbers.ts AGE_QUESTION; build-037).
// Each id is an engine note (`notes.add(text, id, args)`); collected by translator/notes.ts (import.meta.glob).
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  ageQuestion: {
    args: [],
    fi: () =>
      'Ikäkysymys: valyriaksi kysytään ”kuinka monta vuotta X on nähnyt?”, eli skorverdon, jēdaro ja verbin urnegon perfekti (wikin esimerkki ”Skorverdon jēdaro bonys azantys ūndas?” = Kuinka vanha tuo ritari on?).',
    en: () =>
      'Age question: High Valyrian asks “how many years has X seen?”: skorverdon, jēdaro and the perfect of urnegon (the wiki’s example “Skorverdon jēdaro bonys azantys ūndas?” = How old is that knight?).',
  },
  ageQuestionFromHv: {
    args: [],
    fi: () => 'Ikäkysymys: valyrian ”kuinka monta vuotta X on nähnyt?” (skorverdon jēdaro ja verbin urnegon perfekti) on suomeksi ”kuinka vanha X on?”.',
    en: () => 'Age question: High Valyrian “how many years has X seen?” (skorverdon jēdaro with the perfect of urnegon) is “how old is X?”.',
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
